/**
 * Functions exported from this file return user–facing URLs on which
 * fock application is expected to be mounted on.
 * a.k.a. “external routes” or “mount points”
 *
 * Do not confuse with server/utils/routes.
 */

import { stringify } from 'query-string'
import { applyRouteParams, createTenantPath } from 'server/utils/routing'
import { normalizeUrl } from 'shared/utils/url'

abstract class MountPointsBase {
  protected readonly mountPoints: object
  protected readonly tenant: string
  protected readonly language: string
  protected readonly coreShopEnvironment: string
  constructor({ mountPoints, tenant, language, coreShopEnvironment }) {
    this.mountPoints = mountPoints
    this.tenant = tenant
    this.language = language
    this.coreShopEnvironment = coreShopEnvironment
  }

  // eslint-disable-next-line class-methods-use-this
  createQueryString(params): string {
    const stringifiedParams = stringify(params)
    return stringifiedParams.length === 0 ? '' : `?${stringifiedParams}`
  }

  applyCommonRouteParams(route: string): string {
    const tenantPath = createTenantPath(this.tenant, this.coreShopEnvironment)
    return applyRouteParams(route, {
      tenantPath,
      language: this.language
    })
  }

  getUrl(key): string {
    const mountPoint = this.mountPoints[key]

    if (!mountPoint) {
      throw new Error(`mount point for key ${key} does not exist`)
    }

    return normalizeUrl(`${mountPoint}`)
  }
}

export default MountPointsBase
